export default "__VITE_ASSET__BVj0C5aJ__"